import React, {useState,createContext, useContext} from "react";

const MyUserContext = createContext();

export const useUserContext = () => useContext(MyUserContext)

export const MyUserContextProvider = (props) =>{
  const value = JSON.parse(sessionStorage.getItem('user'))
  
  const [user, setUser] = useState(value || {msgcount:0});
 

  const updateUser = (msgcount) =>{
    sessionStorage.setItem('user', JSON.stringify({...user,msgcount}));
    setUser(vl =>({...vl,msgcount}))
  }

  return(
    <MyUserContext.Provider value = {{user,setUser,updateUser}}>
      {props.children}
    </MyUserContext.Provider>
  )
}

